module.exports = __webpack_public_path__ + "img/flipkart GS.a135a720.svg";